import React from 'react'
import QuickAction2 from '../../Components/Bills/QuickAction2'

function Bills() {
  return (
    <div>
    <h1 className=' mb-4 font-extrabold'>Bills payment</h1>
        <QuickAction2/>
    </div>
  )
}

export default Bills